module.exports = __webpack_public_path__ + "img/0.aaa136a0.jpeg";